import { render, staticRenderFns } from "./SupplierPurchases.vue?vue&type=template&id=3620bda1&"
import script from "./SupplierPurchases.vue?vue&type=script&lang=js&"
export * from "./SupplierPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports